import i18n from '@signavio/i18n';
export default function choice({
  value,
  type
}) {
  if (value && !type.options.find(({
    id
  }) => id === value)) {
    return [i18n('Please select one of the available options.')];
  }
  return [];
}